import Layout from '@components/organisms/Layouts/WithoutSidebar'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import RouteNavBar from '@components/pages/help-centre/RouteNavBar/RouteNavBar'
import TabBar from '@components/pages/help-centre/TabBar/TabBar'
import Topics from '@components/pages/help-centre/Topics/Topics'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useTranslation } from 'react-i18next'
import {
  PageContainer,
  PageContent,
  PageTitle,
  PageSubTitle,
} from '@styled_components/helpCentre/styled.components'

export const getStaticProps = async ({ params, locale }) => {
  return {
    props: {
      category: params.articleCategory,
      ...(await serverSideTranslations(locale, [
        'common',
        'home',
        'authentication',
        'footer',
        'courses',
        'signUp',
        'wishlist',
        'helpCentre',
      ])),
    },
  }
}

export const getStaticPaths = () => {
  const paths = ['student', 'author', 'referral-partner', 'legal'].flatMap(
    (x) =>
      ['en', 'uk'].map((ln) => ({ params: { articleCategory: x }, locale: ln }))
  )
  // params: {
  //   category: x,
  // }
  return {
    paths,
    fallback: false,
  }
}

type Category = 'student' | 'author' | 'referralPartner' | 'legal'

const URLParamsToTopicCategoriesMap = new Map<string, Category>([
  ['student', 'student'],
  ['author', 'author'],
  ['referral-partner', 'referralPartner'],
  ['legal', 'legal'],
])

const getTopicFromURLParam = (urlParam?: string) => {
  return URLParamsToTopicCategoriesMap.get(urlParam || '')
}

const getURLParamFromTopic = (topic: Category) => {
  for (const [key, value] of URLParamsToTopicCategoriesMap.entries()) {
    if (value == topic) return key
  }
}

const HelpCentre = () => {
  const { t } = useTranslation('helpCentre')

  const router = useRouter()

  const [currentCategory, setCurrentCategory] = useState<Category>('student')

  useEffect(() => {
    const category = router.query.articleCategory as string | undefined
    const mappedCategory = getTopicFromURLParam(category)

    if (mappedCategory) {
      setCurrentCategory(mappedCategory)
    }
    // getShortStatistics(3, 'uI0kYP2SHNVhRpT2YA36PcUqIPI3').then((res) =>
    // )

    // getTransactionsGraphData(
    //   new Date('2023-11-01EST'),
    //   new Date('2023-12-01EST'),
    //   'uI0kYP2SHNVhRpT2YA36PcUqIPI3',
    //   'purchased',
    //   ['6559df1add09715c1762205e']
    // ).then((res) => )

    // getEarningsGraphData(
    //   new Date('2023-11-01EST'),
    //   new Date('2024-03-01EST'),
    //   'uI0kYP2SHNVhRpT2YA36PcUqIPI3',
    //   'total',
    //   null
    // ).then((res) => )

    // getRatingsGraphData(
    //   new Date('2023-11-01EST'),
    //   new Date('2023-12-01EST'),
    //   null
    // ).then((res) => )

    // getStudentsGraphData(
    //   new Date('2023-11-01EST'),
    //   new Date('2023-12-01EST'),
    //   'total',
    //   ['6559df1add09715c1762205e']
    // ).then((res) => )
  }, [router.query.articleCategory])

  return (
    <Layout displayHeaderAsHelpCentre={true}>
      <PageContainer>
        <PageContent>
          <RouteNavBar
            currentCategory={currentCategory}
            setCategory={(x) => {
              setCurrentCategory(x)
              router.push(
                {
                  pathname: `/help-centre/${getURLParamFromTopic(x)}`,
                },
                undefined,
                { shallow: true } // doesnt do nun
              )
            }}
          />
          <PageTitle>{t('allTopics')}</PageTitle>
          <PageSubTitle>{t('browseHelpTopics')}</PageSubTitle>
          <TabBar
            currentCategory={currentCategory}
            setCategory={(x) => {
              setCurrentCategory(x)

              router.push(
                {
                  pathname: `/help-centre/${getURLParamFromTopic(x)}`,
                },
                undefined,
                { shallow: true }
              )
            }}
          />
          <Topics category={currentCategory} />
        </PageContent>
      </PageContainer>
    </Layout>
  )
}

export default HelpCentre
